"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("@eres/api");
var dev = {
    askMalikAPI: function () { return new api_1.BaseAPIConfig("https", "devgate.dubailand.gov.ae", "reralive"); },
    dldCmsAPI: function () { return new api_1.BaseAPIConfig("https", "devgate.dubailand.gov.ae", "dld-cms"); },
};
var qa = {
    askMalikAPI: function () { return new api_1.BaseAPIConfig("https", "stgapi.dubailand.gov.ae", "reralive"); },
    dldCmsAPI: function () { return new api_1.BaseAPIConfig("https", "stgapi.dubailand.gov.ae", "dld-cms"); },
};
var prod = {
    askMalikAPI: function () { return new api_1.BaseAPIConfig("https", "gateway.dubailand.gov.ae", "reralive"); },
    dldCmsAPI: function () { return new api_1.BaseAPIConfig("https", "gateway.dubailand.gov.ae", "dld-cms"); },
};
var configs = {
    dev: dev,
    qa: qa,
    production: prod,
};
var cfg = api_1.buildConfig("dev", configs);
exports.default = cfg;
